export const NS_USER: string = "user";
